import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { gameConfigStore } from '@pascal/pascal-core';

import { liveConnection } from './liveConnection';

export const SocketConnection = observer(({ children }) => {
  const { gameTypeId } = gameConfigStore;

  useEffect(() => {
    liveConnection.handleSocketInit();
  }, []);

  useEffect(() => {
    liveConnection.connectionInitCallback(false);
  }, [gameTypeId]);

  return children;
});
